import { useState, useCallback, useEffect } from "react";
import { ResetFiltersButton } from "@/components/common/ResetFiltersButton";
import { useSearchParams } from "react-router-dom";
import { PageHeader } from "@/components/common/PageHeader";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { FinanceSummary } from "@/components/finance/FinanceSummary";
import { FinanceOverview } from "@/components/finance/FinanceOverview";
import { TransactionsPanel } from "@/components/finance/TransactionsPanel";
import { BudgetsPanel } from "@/components/finance/BudgetsPanel";
import { FundingPanel } from "@/components/finance/FundingPanel";
import { ForecastPanel } from "@/components/finance/ForecastPanel";

const FIN_TABS = ["overview", "transactions", "budgets", "funding", "forecast"];

export default function FinanceRunway() {
  const [searchParams, setSearchParams] = useSearchParams();
  const [bump, setBump] = useState(0);
  const refresh = useCallback(() => setBump((b) => b + 1), []);

  const tabParam = searchParams.get("tab");
  const tab = FIN_TABS.includes(tabParam) ? tabParam : "overview";
  const filter = searchParams.get("filter");
  const openIds = { transaction: searchParams.get("transaction"), budget: searchParams.get("budget"), funding: searchParams.get("funding") };

  const changeTab = (v) => { const p = new URLSearchParams(searchParams); p.set("tab", v); ["filter", "transaction", "budget", "funding"].forEach((k) => p.delete(k)); setSearchParams(p); };
  const clearFilter = () => { const p = new URLSearchParams(searchParams); p.delete("filter"); setSearchParams(p); };
  const consumeParam = (k) => { const p = new URLSearchParams(searchParams); p.delete(k); setSearchParams(p, { replace: true }); };

  return (
    <>
      <PageHeader
        eyebrow="Finance & Runway"
        title="Finance & Runway"
        description="A practical view of cash, spending, funding and runway. This is a management dashboard for oversight — not a replacement for bookkeeping or accounting software."
      />

      <div className="mb-8"><FinanceSummary refreshKey={bump} /></div>

      <ResetFiltersButton /><Tabs value={tab} onValueChange={changeTab} className="w-full">
        <TabsList data-testid="finance-tabs" className="mb-6 flex h-auto flex-wrap justify-start gap-1.5 rounded-full border border-[#E4E9F3] bg-white p-1.5 shadow-sm">
          {[["overview", "Overview"], ["transactions", "Transactions"], ["budgets", "Budgets"], ["funding", "Funding"], ["forecast", "Forecast"]].map(([v, l]) => (
            <TabsTrigger key={v} value={v} data-testid={`tab-${v}`} className="rounded-full px-4 py-1.5 text-sm font-semibold text-[#5A6B8C] transition-colors data-[state=active]:text-white data-[state=active]:[background-color:var(--accent-primary)]">{l}</TabsTrigger>
          ))}
        </TabsList>

        <TabsContent value="overview"><FinanceOverview refreshKey={bump} /></TabsContent>
        <TabsContent value="transactions"><TransactionsPanel onChange={refresh} filter={filter} openId={openIds.transaction} onConsume={() => consumeParam("transaction")} onClearFilter={clearFilter} /></TabsContent>
        <TabsContent value="budgets"><BudgetsPanel onChange={refresh} /></TabsContent>
        <TabsContent value="funding"><FundingPanel onChange={refresh} openId={openIds.funding} onConsume={() => consumeParam("funding")} /></TabsContent>
        <TabsContent value="forecast"><ForecastPanel onChange={refresh} /></TabsContent>
      </Tabs>
    </>
  );
}
